import React from 'react'

const Footer = () => {
	return (
		<footer>
			<div id='credits'>
				<p>
					<a href='https://www.instagram.com' target='_blank' rel='noreferrer'>
						@xtophe-xanon
					</a>
					<br />
					Made by{' '}
					<a
						href='http://www.christopherconcannon.com'
						target='_blank'
						rel='noreferrer'
					>
						Armadillo World Webquarters
					</a>
				</p>
			</div>
		</footer>
	)
}

export default Footer
